import { Stack, Box } from '@mui/material';
import TransAuthInput from '@/views/components/componentsUI/TransAuthInput';
import ButtonElement from '@/views/elements/button/ButtonElement';
import { submitRegisterMaster } from '@/controllers/gridManager/masterTransManager/masterTransManager';
import classNames from 'classnames/bind';
import styles from './RegisterMasterModalStep.module.scss';
import ToastUtil from '@/views/components/Toast/Toast';
import { useAccounts } from '@/controllers/gridManager/accountsManager/accountManager';
import { setMsgSocketRegisterAction, setStateLoadingAction } from '@/stores/dataManager/Actions/appAction';
import { useEffect, useRef, useState } from 'react';
import { getConfigFromWindowBrowser } from '@/utilities';
import { ENV } from '@/utilities/EWindow';
import { useGetMsgSocketRegister, useGetStatusRegisterMF } from '@/controllers/gridManager/appManager/appManager';
import { useTheme } from '@mui/system';
import { useTranslation } from 'react-i18next';

const cx = classNames.bind(styles);
const SOCKET_NOTIFICATION_TIME_WAIT = getConfigFromWindowBrowser(ENV.SOCKET_NOTIFICATION_TIME_WAIT) ?? 5

type RegisterMasterStep2Props = {
    data: {
        baldefovd: string;
        monthtraded: string;
        netasset: string;
        minmonthtraded: string;
        custodycd: string;
        minnetasset: string;
    },
    handleBackStep?: () => void,
    handleNextStep?: (data: any) => void,
    handleClose?: () => void,
}

const RegisterMasterModalStep2 = ({ data, handleBackStep, handleNextStep, handleClose }: RegisterMasterStep2Props) => {
    const { t } = useTranslation()
    const theme = useTheme()
    const refInterval = useRef<number | null>(null)
    const { accounts } = useAccounts()
    const { statusRegisterMF } = useGetStatusRegisterMF()
    const { msgSocketRegister } = useGetMsgSocketRegister()
    const [authInput, setAuthInput] = useState({
      tokenid: '',
      transactionId: '',
      authtype: '',
      code: '',
      isSaveVerify: false
    });

    const handleAuthInputChange = (input: any) => {
        setAuthInput(input)
    }

    useEffect(() => {
        if (statusRegisterMF !== null) {
            refInterval.current && clearInterval(refInterval.current);
            setStateLoadingAction(false)
            if (statusRegisterMF === 'CONFIRM') {
                !!handleNextStep && handleNextStep(null)
            } else {
                msgSocketRegister && ToastUtil.error(msgSocketRegister)
                setMsgSocketRegisterAction(null)
            }
        }
    }, [statusRegisterMF, msgSocketRegister])

    const handleRegister = async () => {
        setStateLoadingAction(true)
        const { tokenid, transactionId, authtype, code, isSaveVerify } = authInput;
        const response = await submitRegisterMaster(accounts?.[0]?.acctno, tokenid, transactionId, authtype, code, isSaveVerify);
        if (response.isSuccess) {
            await countdown(SOCKET_NOTIFICATION_TIME_WAIT)
        }
        setStateLoadingAction(false)
    }

    const countdown = async (seconds: number) => {
        return new Promise((resolve, reject) => {
            let remainingTime = seconds;
            refInterval.current = setInterval(() => {
                remainingTime--;
                if (remainingTime < 0) {
                    if (refInterval.current) {
                        clearInterval(refInterval.current);
                        refInterval.current = null
                    }
                    setStateLoadingAction(false)
                    ToastUtil.success(t('copytrade.registerMaster.acknowledgedRequest'))
                    !!handleClose && handleClose()
                    resolve(true);
                }
            }, 1000);
        });
    }

    return (
        <Box>
            <Stack
                direction={"column"}
                spacing={2}
            >
                <Stack
                    direction={"column"}
                    borderRadius={1}
                    bgcolor={theme.palette.background.badge}
                    py={1}
                    px={1}
                >
                    <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                        bgcolor={theme.palette.background.badge}
                    >
                        <Box>
                            {t('copytrade.registerMaster.custodycd')}
                        </Box>
                        <Box>
                            {data.custodycd}
                        </Box>
                    </Stack>
                    <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                    >
                        <Box>
                            {t('copytrade.registerMaster.netasset')}
                        </Box>
                        <Box>
                            {data.netasset}
                        </Box>
                    </Stack>
                </Stack>

                <Box>
                    <TransAuthInput
                        onChange={handleAuthInputChange}
                    />
                </Box>

                <Stack
                    direction={"row"}
                    spacing={2}
                    justifyContent={"center"}
                >
                    <ButtonElement className={cx("footer-btn")} variant="contained"
                        onClick={() => !!handleBackStep && handleBackStep()}>{t('copytrade.common.back')}</ButtonElement>
                    <ButtonElement className={cx("footer-btn")} variant="contained"
                        onClick={handleRegister}>{t('copytrade.common.register')}</ButtonElement>
                </Stack>
            </Stack>
        </Box>
    );
};

export default RegisterMasterModalStep2;